/**
 * Core UI Icons
 *
 * Essential navigation, modal, and form controls used throughout the app.
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faChevronUp as fasChevronUp,
  faChevronDown as fasChevronDown,
  faChevronLeft as fasChevronLeft,
  faChevronRight as fasChevronRight,
  faCheck as fasCheck,
  faSpinner as fasSpinner,
  faTimes as fasTimes,
  faCog as fasCog,
  faArrowsRotate as fasArrowsRotate,
  faArrowUp as fasArrowUp,
  faArrowDown as fasArrowDown,
  faArrowLeft as fasArrowLeft,
  faArrowRight as fasArrowRight,
  faEllipsisVertical as fasEllipsisVertical,
  faEllipsis as fasEllipsis,
  faCircle as fasCircle,
  faSquare as fasSquare,
  faUsers as fasUsers,
  faPencil as fasPencil,
  faPlus as fasPlus,
  faMinus as fasMinus,
  faMagnifyingGlass as fasMagnifyingGlass,
  faPlay as fasPlay,
  faPause as fasPause,
  faFloppyDisk as fasFloppyDisk,
  faTrash as fasTrash,
  faXmark as fasXmark,
  faMicrophone as fasMicrophone,
  faShieldCheck as fasShieldCheck,
  faLock as fasLock,
  faListCheck as fasListCheck,
  faFolderOpen as fasFolderOpen,
  faPenToSquare as fasPenToSquare,
  faClockRotateLeft as fasClockRotateLeft,
  faCopy as fasCopy,
  faCamera as fasCamera,
  faEye as fasEye,
  faEyeSlash as fasEyeSlash,
  faCircleCheck as fasCircleCheck,
  faCircleNotch as fasCircleNotch,
  faCircleExclamation as fasCircleExclamation,
  faLinkSlash as fasLinkSlash,
  faCalendarAlt as fasCalendarAlt,
  faCircleDot as fasCircleDot,
  faArrowUpRightFromSquare as fasArrowUpRightFromSquare,
  faFileImage as fasFileImage,
  faBan as fasBan,
  faShareNodes as fasShareNodes,
  faPen as fasPen,
  faLink as fasLink,
  faWifi as fasWifi,
  faBuildingShield as fasBuildingShield,
  faPersonCircleExclamation as fasPersonCircleExclamation,
  faMessageExclamation as fasMessageExclamation,
  faArrowRotateRight as fasArrowRotateRight,
  faPaperclip as fasPaperclip,
  faReply as fasReply,
  faFileImport as fasFileImport,
  faFilter as fasFilter,
  faCheckCircle as fasCheckCircle,
  faClock as fasClock,
  faCircleInfo as fasCircleInfo,
  faQrcode as fasQrCode,
  faRotate as fasRotate,
  faRotateLeft as fasRotateLeft,
  faForward as fasForward,
  faUserSlash as fasUserSlash,
  faKeyboard as fasKeyboard,
  faHandshake as fasHandshake,
} from '@fortawesome/pro-solid-svg-icons';

import {
  faChevronLeft as fadChevronLeft,
  faChevronRight as fadChevronRight,
  faChevronUp as fadChevronUp,
  faChevronDown as fadChevronDown,
  faTimes as fadTimes,
  faSearch as fadSearch,
  faSpinner as fadSpinner,
  faTrash as fadTrash,
  faCog as fadCog,
  faSliders as fadSliders,
  faSun as fadSun,
  faMoon as fadMoon,
  faArrowLeft as fadArrowLeft,
  faArrowRight as fadArrowRight,
  faArrowUp as fadArrowUp,
  faArrowDown as fadArrowDown,
  faArrowsRotate as fadArrowsRotate,
  faCircleXmark as fadCircleXmark,
  faPlus as fadPlus,
  faCheck as fadCheck,
  faPencil as fadPencil,
  faXmark as fadXmark,
  faNotesMedical as fadNotesMedical,
  faFolderOpen as fadFolderOpen,
  faListCheck as fadListCheck,
  faShieldCheck as fadShieldCheck,
  faLock as fadLock,
  faMicrophone as fadMicrophoneCore,
  faClockRotateLeft as fadClockRotateLeft,
  faPenToSquare as fadPenToSquare,
  faCircleHalfStroke as fadCircleHalfStroke,
  faVolumeHigh as fadVolumeHigh,
  faMessageSms as fadMessageSms,
  faWarning as fadWarning,
  faQrcode as fadQrcode,
  faUserCircle as fadUserCircle,
  faUserShield as fadUserShield,
  faUser as fadUser,
  faShieldKeyhole as fadShieldKeyhole,
  faArrowRightFromBracket as fadArrowRightFromBracket,
  faCheckCircle as fadCheckCircle,
  faExclamationCircle as fadExclamationCircle,
  faCamera as fadCamera,
  faFingerprint as fadFingerprint,
  faFaceViewfinder as fadFaceViewfinder,
  faCircleInfo as fadCircleInfo,
  faThumbsUp as fadThumbsUp,
  faThumbsDown as fadThumbsDown,
  faShareFromSquare as fadShareFromSquare,
  faClock as fadClock,
  faLocationDot as fadLocationDot,
  faCopy as fadCopy,
  faCalendarDays as fadCalendarDays,
  faCreditCard as fadCreditCard,
  faTicket as fadTicket,
  faFolderMedical as fadFolderMedical,
  faHardDrive as fadHardDrive,
  faWaveformLines as fadWaveformLines,
  faShieldHeart as fadShieldHeart,
  faFileImage as fadFileImage,
  faFileImport as fadFileImport,
  faFileShield as fadFileShield,
  faWifi as fadWifi,
  faVault as fadVault,
  faIdCard as fadIdCard,
  faLandmarkFlag as fadLandmarkFlag,
  faMessageMedical as fadMessageMedical,
  faWatch as fadWatch,
  faLink as fadLink,
  faShieldExclamation as fadShieldExclamation,
  faBuildingShield as fadBuildingShield,
  faPersonCircleExclamation as fadPersonCircleExclamation,
  faMessageExclamation as fadMessageExclamation,
  faCloudArrowUp as fadCloudArrowUp,
  faCloudArrowDown as fadCloudArrowDown,
  faBarcodeScan as fadBarcodeScan,
  faCameraSlash as fadCameraSlash,
  faFileContract as fadFileContract,
  faFlask as fadFlask,
  faEnvelopeOpenText as fadEnvelopeOpenText,
  faInbox as fadInbox,
  faAt as fadAt,
  faPaperPlane as fadPaperPlane,
  faBell as fadBell,
  faFileInvoiceDollar as fadFileInvoiceDollar,
  faSchool as fadSchool,
  faRotate as   fadRotate,
  faBellSlash as fadBellSlash,
  faCircleCheck as fadCircleCheck,
  faPen as fadPen,
  faHeartPulse as fadHeartPulse,
  faPersonFalling as fadPersonFalling,
  faLungs as fadLungs,
  faHeartCrack as fadHeartCrack,
  faHeartCircleExclamation as fadHeartCircleExclamation,
  faCircleMinus as fadCircleMinus,
  faHouseHeart as fadHouseHeart,
  faBasketShopping as fadBasketShopping,
  faClipboardCheck as fadClipboardCheck,
  faSoap as fadSoap,
  faFlag as fadFlag,
  faShare as fadShare,
  faFolderArrowUp as fadFolderArrowUp,
  faUsersGear as fadUsersGear,
  faCirclePlus as fadCirclePlus,
  faArrowUpRight as fadArrowUpRight,
  faSirenOn as fadSirenOn,
  faCloudSun as fadCloudSun,
  faMoonStars as fadMoonStars,
  faCheckDouble as fadCheckDouble,
  faFilePen as fadFilePen,
  faBook as fadBook,
  faMicrophoneLines as fadMicrophoneLines,
  faRotateLeft as fadRotateLeft,
  faForward as fadForward,
  faUserSlash as fadUserSlash,
  faFileExport as fadFileExport,
  faNewspaper as fadNewspaper,
  faMessagesQuestion as fadMessagesQuestion,
  faLocationCrosshairs as fadLocationCrosshairs,
  faFilter as fadFilter,
  faArrowUpRightFromSquare as fadArrowUpRightFromSquare,
  faHandshake as fadHandshake,
} from '@fortawesome/pro-duotone-svg-icons';

export const loadCoreIcons = () => {
  library.add(
    fasChevronUp,
    fasChevronDown,
    fasChevronLeft,
    fasChevronRight,
    fasCheckCircle,
    fasCheck,
    fasSpinner,
    fasTimes,
    fasCog,
    fasArrowsRotate,
    fasArrowUp,
    fasArrowDown,
    fasArrowLeft,
    fasArrowRight,
    fasEllipsisVertical,
    fasEllipsis,
    fasCircle,
    fasSquare,
    fasUsers,
    fasPencil,
    fasPlus,
    fasMinus,
    fasMagnifyingGlass,
    fasCalendarAlt,
    fadCalendarDays,

    fadChevronLeft,
    fadChevronRight,
    fadChevronUp,
    fadChevronDown,
    fadTimes,
    fadSearch,
    fadSpinner,
    fadTrash,
    fadCog,
    fadSliders,
    fadSun,
    fadMoon,
    fadArrowLeft,
    fadArrowRight,
    fadArrowUp,
    fadArrowDown,
    fadArrowsRotate,
    fadCircleXmark,
    fadPlus,
    fadCheck,
    fadPencil,
    fadXmark,
    fadNotesMedical,
    fadFolderOpen,
    fadListCheck,
    fadShieldCheck,
    fadLock,
    fadMicrophoneCore,
    fadClockRotateLeft,
    fadPenToSquare,
    fadCircleHalfStroke,
    fadVolumeHigh,
    fadMessageSms,
    fadWarning,
    fadQrcode,
    fadUserCircle,
    fadUserShield,
    fadUser,
    fadShieldKeyhole,
    fadArrowRightFromBracket,

    fasCamera,
    fasEye,
    fasEyeSlash,
    fadCheckCircle,
    fadExclamationCircle,
    fadCamera,
    fadFingerprint,
    fadFaceViewfinder,
    fadCircleInfo,

    fasPlay,
    fasPause,
    fasFloppyDisk,
    fasTrash,
    fasXmark,
    fasMicrophone,
    fasShieldCheck,
    fasLock,
    fasListCheck,
    fasFolderOpen,
    fasPenToSquare,
    fasClockRotateLeft,
    fasCopy,
    fadThumbsUp,
    fadThumbsDown,
    fadShareFromSquare,

    fasCircleCheck,
    fasCircleNotch,
    fasCircleExclamation,
    fasLinkSlash,
    fadClock,
    fadLocationDot,
    fadCopy,
    fadCreditCard,
    fadTicket,
    fadFolderMedical,
    fadHardDrive,
    fasCircleDot,
    fasArrowUpRightFromSquare,
    fadWaveformLines,
    fadShieldHeart,
    fadFileImage,
    fasFileImage,
    fadFileImport,
    fadFileShield,
    fadWifi,
    fadVault,
    fadIdCard,
    fadLandmarkFlag,
    fadMessageMedical,
    fadWatch,
    fasBan,
    fasShareNodes,
    fasPen,
    fasLink,
    fasWifi,
    fadLink,
    fadShieldExclamation,
    fadBuildingShield,
    fadPersonCircleExclamation,
    fadMessageExclamation,
    fasBuildingShield,
    fasPersonCircleExclamation,
    fasMessageExclamation,
    fasArrowRotateRight,
    fadCloudArrowUp,
    fadCloudArrowDown,
    fadBarcodeScan,
    fadCameraSlash,
    fasPaperclip,
    fasReply,
    fasFileImport,
    fadFileContract,
    fadFlask,
    fadEnvelopeOpenText,
    fadInbox,
    fadAt,
    fadPaperPlane,
    fadBell,
    fadFileInvoiceDollar,
    fadSchool,
    fadRotate,
    fasFilter,
    fadBellSlash,
    fadCircleCheck,
    fadPen,
    fadHeartPulse,
    fadPersonFalling,
    fadLungs,
    fadHeartCrack,
    fadHeartCircleExclamation,
    fadCircleMinus,
    fadHouseHeart,
    fadBasketShopping,
    fadClipboardCheck,
    fadSoap,
    fadFlag,
    fadShare,
    fadFolderArrowUp,
    fasClock,
    fadUsersGear,
    fasCircleInfo,
    fadCirclePlus,
    fadArrowUpRight,
    fasQrCode,
    fasRotate,
    fadSirenOn,
    fadCloudSun,
    fadMoonStars,
    fadCheckDouble,
    fadFilePen,
    fadBook,
    fadMicrophoneLines,
    fadRotateLeft,
    fadForward,
    fasRotateLeft,
    fasForward,
    fadUserSlash,
    fasUserSlash,
    fasKeyboard,
    fadFileExport,
    fadNewspaper,
    fadMessagesQuestion,
    fadLocationCrosshairs,
    fadFilter,
    fadArrowUpRightFromSquare,
    fasHandshake,
    fadHandshake,
  );
};
